import _get from 'lodash/get'
import { autorun } from 'mobx'

export const StorageApi = (storage) => {
  
  async function setItem(key, data) {
    if( storage ) {
      storage.setItem(key, JSON.stringify(data))
    }
  }
  
  async function getItem(key) {
    if( !storage ) return null
    let data = null
    
    try {
      data = JSON.parse(storage.getItem(key))
    } catch( e ) {
      return null
    }
    
    return data
  }
  
  async function removeItem(key) {
    if( storage ) {
      storage.removeItem(key)
    }
  }
  
  return {
    setItem,
    getItem,
    removeItem,
    _storage: storage
  }
}

export const LocalStorage = StorageApi(_get(window, 'localStorage', false))
export const SessionStorage = StorageApi(_get(window, 'sessionStorage', false))

const Storage = (storageKey, observeOn = {}, storageApi = LocalStorage, serializer = val => val) => {
  
  let cache = null
  
  async function get(emptyVal = null) {
    if( cache ) return cache
    return await storageApi
      .getItem(storageKey)
      .then(result => result === null ? emptyVal : result)
  }
  
  async function put(data) {
    await storageApi.setItem(storageKey, serializer(data))
    cache = !data ? null : data
  }
  
  async function remove() {
    await storageApi.removeItem(storageKey)
    cache = null
  }
  
  function clearCache() {
    cache = null
  }
  
  if(observeOn) {
    autorun(() => {
      const val = observeOn[ storageKey ]
      
      if(val) {
        put(val)
      }
    })
  }
  
  return {
    get,
    put,
    remove,
    _clearCache: clearCache,
    _storageApi: storageApi
  }
}

Storage.LocalStorage = LocalStorage
Storage.SessionStorage = SessionStorage
Storage.StorageApi = StorageApi

export default Storage
